"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.About = void 0;
/*
 * © 2017 Renishaw plc. All rights reserved.
 * This source file is the confidential property and copyright of Renishaw plc
 * Reproduction or transmission in whole or in part, in any form or
 * by any means, electronic, mechanical or otherwise, is prohibited
 * without the prior written consent of the copyright owner.
 */
const react_1 = __importDefault(require("react"));
const Base_1 = require("./Base");
const About = ({ title, size = 16, ...rest }) => (react_1.default.createElement(Base_1.Base, { size: size, smooth: true, ...rest, viewBox: "0 0 32 32" },
    react_1.default.createElement("title", null, title),
    react_1.default.createElement("path", { d: "M16,6.9c0-1,0.8-1.9,1.7-1.9c0.9,0,1.7,0.9,1.7,1.9s-0.8,1.9-1.7,1.9S16,7.9,16,6.9z" }),
    react_1.default.createElement("path", { d: "M19.2,21.7c0,3.4-6.1,4.4-5.8,2l2.2-11.9c-1.1-0.2-2.7,2.1-3,2.6c0.1-3.9,6.4-4.9,5.8-2.9l-2.3,12.4\n\t\tC17.3,23.8,18.9,22.6,19.2,21.7z" })));
exports.About = About;
//# sourceMappingURL=About.js.map